export default class CredibleDamageViewModel {
    public name: string = '';
    public id: number | null = null;
    public status: boolean = false;
    public custom: boolean = false;
    public location: string | null = null;
    public preparation: string | null = null;
    public inspectionRequirement: string | null = null;
}